export enum QueueProcessingSection {
    processes = 'processes',
    upload = 'upload',
    groupDetail = 'groupDetail',
}
